<template>
  <div>
    <v-expansion-panels flat id="filters-panels">
      <v-expansion-panel>
        <v-expansion-panel-header>
          {{ $t("filters.title") }}
        </v-expansion-panel-header>
        <v-expansion-panel-content class="filters-content">
          <v-btn
            rounded
            outlined
            class="neumorphism-curved"
            @click="clearFilter"
            color="red darken-1"
          >
            {{ $t("filters.reset") }}
          </v-btn>

          <div class="filters">
            <users-filter class="users-filter" ref="userFilterTest">
            </users-filter>

            <events-filter class="events-filter" @clear-filter="clearFilter">
            </events-filter>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>
          {{ $t("definition.captionLocation") }}
        </v-expansion-panel-header>
        <v-expansion-panel-content class="filters-content">
          <CaptionLocation />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import UsersFilter from "./UsersFilter";
import EventsFilter from "./EventsFilter.vue";
import CaptionLocation from "./CaptionLocation.vue";

export default {
  props: [],
  components: {
    UsersFilter,
    EventsFilter,
    CaptionLocation,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("userModule", { users: "getUsers" }),
    ...mapGetters("eventModule", { events: "getEvents" }),
  },
  mounted() {},
  methods: {
    ...mapActions("eventModule", ["updateEventsMultiarray"]),
    ...mapActions("userModule", ["updateUsersMultiarray"]),
    /**
     * This method will clear both event and user filters.
     * The event filter is using the following object to save parameters selected => eventsMultiArray: { city: null, option: null, validated: null }
     * The user filter is using the following object to save parameters selected => usersMultiArray: { locations: [], users: [], skills: [], companies: [] }
     * These two objects will be reset after this method was called
     */
    clearFilter() {
      this.updateUsersMultiarray({
        locations: [],
        users: [],
        skills: [],
        companies: [],
      });
      this.updateEventsMultiarray({
        city: null,
        option: null,
        validated: null,
        course: null,
      });
      this.users.forEach((u) => {
        u.display = true;
      });
      this.events.forEach((e) => {
        e.display = true;
      });
      this.$refs.userFilterTest.LoadMultifiltersData();
    },
  },
};
</script>

<style lang="scss">
#filters-panels {
  & > div {
    background-color: rgba(255, 255, 255, 0);
  }
  .filters {
    display: grid;
    grid-template-rows: 1fr;
    grid-template-columns: 1fr 1fr;
    margin: 20px 0 0;
    .users-filter,
    .events-filter {
      margin: 10px 20px 10px 0;
    }
  }
}
.filters-content {
  display: flex;
}
#btn3 {
  margin: 10px 10px 10px 0;
}
</style>
